/** VS Code Marketplace — packages/plugin-anypoint-builder (publisher + package id) */
export const ANYPOINT_BUILDER_MARKETPLACE_URL =
  'https://marketplace.visualstudio.com/items?itemName=CurieTechAI.curietech-ai'

/**
 * Eclipse p2 update site. The API serves the repository from a private S3
 * bucket (`GET /plugins/anypoint-studio/{file}`), and each environment's API
 * serves the repository published for that environment — so the app's own API
 * base URL is the only input.
 *
 * This is the URL users paste into Eclipse: Help → Install New Software.
 */
export function getAnypointStudioP2RepositoryUrl(apiBaseUrl: string): string {
  return `${apiBaseUrl.replace(/\/+$/, '')}/plugins/anypoint-studio`
}

/**
 * URL to open in a browser: the repository root itself is p2 metadata, so the
 * upload script publishes an `index.html` alongside it with install steps.
 */
export function getAnypointStudioP2BrowserUrl(apiBaseUrl: string): string {
  return `${getAnypointStudioP2RepositoryUrl(apiBaseUrl)}/index.html`
}
